import React from 'react'
import Link from 'gatsby-link'

import Logo from '../logo'
import { Image } from '../utils/lazyImage'

import Styles from '../../styles/components/footer.module.scss'
// const { footer, footerLogo } = Styles

class Footer extends React.PureComponent {
  render() {
    return (
      <div className={Styles.footer}>
        <div className={Styles.flex}>
          <div className={Styles.footerLogo}>
            <Link to="/">
              <Logo light width={203} />
            </Link>
          </div>
          <div className={Styles.texts}>
            {this.props.options.footer_text &&
              this.props.options.footer_text.map((column_text, index) => (
                <div
                  className={Styles.text}
                  key={index}
                  dangerouslySetInnerHTML={{
                    __html: column_text.kolumna,
                  }}
                />
              ))}
          </div>
          {this.props.options.social_media && (
            <div className={Styles.socialContainer}>
              {this.props.options.social_media.map((smItem, index) => (
                <a
                  href={smItem.link}
                  target="_blank"
                  key={index}
                  rel="noopener"
                  className={Styles.socialItem}
                  style={{
                    width:
                      smItem.image.localFile.childImageSharp.original.width,
                  }}
                >
                  <Image sizes={smItem.image.localFile.childImageSharp.sizes} />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.js